/* eslint-disable consistent-return */
import './combosingleproduct.scss';

import { useState } from 'react';
import { FaCheckCircle, FaShoppingCart } from 'react-icons/fa';

import Price from '@/resources/components/product/price/Price';
import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { IMainProduct } from '@/store/ducks/combos/types';

import { submitComboPromotion } from '../../utils/comboUtils';
import { LabelIcon } from './Label';

export function ComboSingleProduct({ product }: { product: IMainProduct }) {
  const { configs, order } = useWebContext();

  const priceWithDiscount = parseFloat(
    (
      product.full_product.price -
      (product.discount_percentage / 100) * product.full_product.price
    ).toFixed(2),
  );

  const cartCheck = order?.cart?.products.find(
    (item) => item.combo_id === product.combo_id && item.price === priceWithDiscount,
  );

  const [isApplied, setIsApplied] = useState(!!cartCheck);

  const buyButtonColor = configs.buy_button_color || '#000000';
  const textColor = useTextColor(buyButtonColor) || '#FFFFFF';
  const price = priceWithDiscount;

  return (
    <div className="combo-single-product">
      <h5
        className="combo-single-product__header"
        style={{
          backgroundColor: buyButtonColor,
          color: textColor,
        }}
      >
        <span className="combo-single-product__header-content">
          Leve{' '}
          <h4 className="combo-single-product__quantity">
            <strong>{product.min_quantity}</strong>
          </h4>{' '}
          und.
        </span>
      </h5>
      <div
        className="combo-single-product__card"
        style={{
          border: `1px solid ${buyButtonColor}`,
        }}
      >
        <LabelIcon color={buyButtonColor} />
        <div className="combo-single-product__content">
          <div className="combo-single-product__price-row">
            <h5>Pague:</h5>{' '}
            <div className="combo-single-product__price">
              <Price price={price} defaultPrice={product.full_product.price} />{' '}
              <span className="pt-3">cada</span>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="combo-single-product__add-button"
          onClick={() => {
            submitComboPromotion({
              orderId: order?.id,
              comboId: product.combo_id,
              onClose: () => {
                setIsApplied(true);
              },
              quantities: { [product.full_product.id]: product.min_quantity },
            });
          }}
          style={{
            borderColor: isApplied ? 'green' : buyButtonColor,
            color: isApplied ? 'green' : buyButtonColor,
          }}
        >
          {' '}
          {!isApplied ? (
            <>
              <strong>ADICIONAR AO CARRINHO</strong>{' '}
              <FaShoppingCart color={buyButtonColor} size={24} />{' '}
            </>
          ) : (
            <div className="px-5 align-items-center">
              <strong className="pr-1">ADICIONADO</strong>
              <FaCheckCircle color="green" size={24} />
            </div>
          )}
        </button>
      </div>
    </div>
  );
}
